import { LotteryCountdown } from "./lottery-countdown";

export class LotteryCountdownCard extends LotteryCountdown {
    private odometers: any;
    public labels: Array<HTMLElement>;
    public parentElement: HTMLElement;

    constructor(parentEl, daysConfig) {
        const game = parentEl.dataset.game;
        let config;

        if (!daysConfig) {
            config = {
                days: false,
                hours: false,
                minutes: true,
                seconds: true,
            };
        } else {
            config = {
                days: true,
                hours: true,
                minutes: true,
                seconds: false,
            };
        }

        super(config, game);
        this.odometers = [...parentEl.querySelectorAll(".countdown-timer")];
        this.labels = [...parentEl.querySelectorAll(".countdown-unit")];
        this.parentElement = parentEl;
    }

    DomRender() {
        const getTotalHours = this.units.indexOf("days") < 0;

        this.units.forEach((unit, i) => {
            const unitText = this.getUnitText(unit, getTotalHours);
            this.odometers[i].innerText = unitText;

            if (this.labels.length > i) this.labels[i].innerText = this.localizeLabel(unit, unitText);
        });
    }
}
